import * as React from 'react';
import { InfoModel } from '../../data/dataStore';
import { genres, formats, physicals } from '../../data/spreadsheetData';





export interface WhoProps {
    data: InfoModel;
    onChanged: (m: InfoModel) => void;
}

const SelectOption = () => <option value="">--- Select ---</option>

export const Who = (props: WhoProps) => {

    const { data, onChanged } = props;

    return <div className="who ">
        <div className="beeom-form">
            <label>Band/artist name</label>
            <input
                maxLength={30}
                value={data.artistName}
                onChange={e => {
                    onChanged({
                        ...data,
                        artistName: e.target.value || "",
                    })
                }}
            />

            <label>Genre</label>
            <select
                value={data.genre}
                onChange={e => {
                    onChanged({
                        ...data,
                        genre: e.target.value || "",
                    })
                }}
            >
                <SelectOption />
                {genres.map(g =>
                    <option
                        key={g}
                        value={g}
                    >{g}</option>
                )}
            </select>

            <label>Single or album</label>
            <select
                value={data.format}
                onChange={e => {
                    onChanged({
                        ...data,
                        format: e.target.value || "",
                    })
                }}
            >
                <SelectOption />
                {formats.map(g =>
                    <option
                        key={g}
                        value={g}
                    >{g}</option>
                )}
            </select>

            <label>Doing Physical?</label>
            <select
                value={data.doingPhysical}
                onChange={e => {
                    onChanged({
                        ...data,
                        doingPhysical: e.target.value,
                    })
                }}
            >
                <SelectOption />
                {physicals.map(g =>
                    <option
                        key={g}
                        value={g}
                    >{g}</option>
                )}
            </select>

            <label>Release name</label>
            <input
                maxLength={30}
                value={data.releaseName}
                onChange={e => {
                    onChanged({
                        ...data,
                        releaseName: e.target.value || "",
                    })
                }}
            />

        </div>
    </div>

}